import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LoanOfficerIndexedDBService } from 'src/app/indexDB/loanOfficer.service';
import { UserService } from 'src/app/pages/staff-management/services/user.service';

@Component({
  selector: 'app-loan-officer-search-select',
  templateUrl: './loan-officer-search-select.component.html',
  styleUrls: ['./loan-officer-search-select.component.css']
})
export class LoanOfficerSearchSelectComponent implements OnInit, OnChanges, OnDestroy {

  @Input() areaId:number = 0;
  @Input() branchId:number = 0;
  @Input() showDefaultListValue:boolean = false;
  @Input() showNoneOption: boolean = false;
  @Input() defaultLabel: string = 'All';
  @Input() defaultSelected:any;
  @Input() disabled: boolean = false;
  @Input() control: FormControl | string = new FormControl();
  @Input() value:number = 0; 
  @Input() type: 'client' | 'server' = 'client';
  @Output() emitSelectedVal: EventEmitter<any> = new EventEmitter();

  public loanOfficerLabel: string = $localize`:@@account_officer:Account Officer`;
  loanOfficersData: { id: number, name: string }[] = [];
  public endpoint: string = '';
  private previousAreaId:number = 0;
  public storedArrayString = localStorage.getItem('indexDBFetched');
  public storedArray = this.storedArrayString ? JSON.parse(this.storedArrayString) : [];
  private subscription: Subscription;
  private retryTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private loanOfficerIDBService: LoanOfficerIndexedDBService,
    private userService: UserService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['value']){
      (this.control as FormControl)?.setValue(this.value);
    }


    if(changes['branchId'] || changes['areaId']) {
      if (changes['branchId']) this.branchId = changes['branchId'].currentValue;
      if (changes['areaId']) this.areaId = changes['areaId'].currentValue;
      const param: any = {
        ...(this.areaId && {areaId: this.areaId}),   
        ...(this.branchId && {branchId: this.branchId})
      }
      if(param.hasOwnProperty('areaId')) this.previousAreaId = param['areaId'];
      const queryParam = new URLSearchParams(param).toString()
      this.endpoint = this.userService.searchLoanOfficerEndpointByParam(queryParam);
      
      if(this.branchId !== undefined && this.branchId !== 0) return this.getLoanOfficersByBranchId(this.branchId);
      if(this.areaId !== undefined && this.areaId !== 0) return this.getLoanOfficersByAreaId(this.areaId);
      if(this.previousAreaId !== 0) return this.getLoanOfficersByAreaId(this.previousAreaId);

      return this.getAllLoanOfficers();

    }

    if(changes['type']) {
      this.type = changes['type'].currentValue;
      if (this.type === 'client') this.getAllLoanOfficers();
    }
    
  }

  ngOnInit(): void {
    // ngOnChanges fires before ngOnInit, and the parent's ngOnInit already ran
    // before this child was created — so branchId/areaId carry real values here
    // when they were set. Only fall back to all officers when no scope is given.
    if (!this.branchId && !this.areaId) {
      this.getAllLoanOfficers();
    }
    this.endpoint = this.userService.searchApprovedLoanOfficerEndpoint;
    if (!this.storedArray.includes('loanOfficer')) {
      this.type = 'server';
    }
  }

  emitSelected(value:{id:any, name:string}) {
    this.emitSelectedVal.emit(value);
  }

  private clearRetry() {
    if (this.retryTimeout !== null) {
      clearTimeout(this.retryTimeout);
      this.retryTimeout = null;
    }
  }

  getAllLoanOfficers(retryCount = 0) {
    this.clearRetry();
    if (this.subscription) this.subscription.unsubscribe();
    this.subscription = this.loanOfficerIDBService.getStoredData().subscribe({
      next: (loanOfficers) => {
        this.loanOfficersData = loanOfficers;
        if (loanOfficers.length === 0 && retryCount < 10) {
          this.retryTimeout = setTimeout(() => this.getAllLoanOfficers(retryCount + 1), 300);
        }
      },
      error: (error) => { console.error('Error retrieving account Officers:', error); }
    });
  }

  getLoanOfficersByBranchId(branchId: number, retryCount = 0) {
    this.clearRetry();
    if (this.subscription) this.subscription.unsubscribe();
    this.subscription = this.loanOfficerIDBService.getStoredLoanOfficersByBranchId(branchId).subscribe({
      next: (loanOfficers) => {
        this.loanOfficersData = loanOfficers;
        if (loanOfficers.length === 0 && retryCount < 10) {
          this.retryTimeout = setTimeout(() => this.getLoanOfficersByBranchId(branchId, retryCount + 1), 300);
        }
      },
      error: (error) => { console.error('Error retrieving account Officers:', error); }
    });
  }

  getLoanOfficersByAreaId(areaId: number, retryCount = 0) {
    this.clearRetry();
    if (this.subscription) this.subscription.unsubscribe();
    this.subscription = this.loanOfficerIDBService.getStoredLoanOfficersByAreaId(areaId).subscribe({
      next: (loanOfficers) => {
        this.loanOfficersData = loanOfficers;
        if (loanOfficers.length === 0 && retryCount < 10) {
          this.retryTimeout = setTimeout(() => this.getLoanOfficersByAreaId(areaId, retryCount + 1), 300);
        }
      },
      error: (error) => { console.error('Error retrieving account Officers:', error); }
    });
  }

  ngOnDestroy(): void {
    this.clearRetry();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
